import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["matters"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      entitySyncListDataSuggestions: build.query<
        EntitySyncListDataSuggestionsApiResponse,
        EntitySyncListDataSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/`,
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["matters"],
      }),
      entitySyncGetDataSuggestionSet: build.query<
        EntitySyncGetDataSuggestionSetApiResponse,
        EntitySyncGetDataSuggestionSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/${queryArg.setId}/`,
        }),
        providesTags: ["matters"],
      }),
      entitySyncDismissDataSuggestionSet: build.mutation<
        EntitySyncDismissDataSuggestionSetApiResponse,
        EntitySyncDismissDataSuggestionSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/${queryArg.setId}/dismiss/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncAcceptDataSuggestion: build.mutation<
        EntitySyncAcceptDataSuggestionApiResponse,
        EntitySyncAcceptDataSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/${queryArg.suggestionId}/accept/`,
          method: "POST",
          body: queryArg.acceptDataSuggestionRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncApplyDataSuggestion: build.mutation<
        EntitySyncApplyDataSuggestionApiResponse,
        EntitySyncApplyDataSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/${queryArg.suggestionId}/apply/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncRejectDataSuggestion: build.mutation<
        EntitySyncRejectDataSuggestionApiResponse,
        EntitySyncRejectDataSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/${queryArg.suggestionId}/reject/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncGenerateDataSuggestions: build.mutation<
        EntitySyncGenerateDataSuggestionsApiResponse,
        EntitySyncGenerateDataSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/generate/`,
          method: "POST",
          body: queryArg.generateSuggestionsRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncGetDataSuggestion: build.query<
        EntitySyncGetDataSuggestionApiResponse,
        EntitySyncGetDataSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/data-suggestions/suggestion/${queryArg.suggestionId}/`,
        }),
        providesTags: ["matters"],
      }),
      entitySyncFieldConfig: build.query<
        EntitySyncFieldConfigApiResponse,
        EntitySyncFieldConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/field-config/`,
        }),
        providesTags: ["matters"],
      }),
      entitySyncRunFullPipeline: build.mutation<
        EntitySyncRunFullPipelineApiResponse,
        EntitySyncRunFullPipelineApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/full-pipeline/`,
          method: "POST",
          body: queryArg.generateSuggestionsRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncGetPipelineStatus: build.query<
        EntitySyncGetPipelineStatusApiResponse,
        EntitySyncGetPipelineStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/full-pipeline/status/`,
          params: {
            workflow_id: queryArg.workflowId,
          },
        }),
        providesTags: ["matters"],
      }),
      entitySyncListLinkSuggestions: build.query<
        EntitySyncListLinkSuggestionsApiResponse,
        EntitySyncListLinkSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/link-suggestions/`,
        }),
        providesTags: ["matters"],
      }),
      entitySyncApproveLinkSuggestion: build.mutation<
        EntitySyncApproveLinkSuggestionApiResponse,
        EntitySyncApproveLinkSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/link-suggestions/${queryArg.suggestionId}/approve/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncRejectLinkSuggestion: build.mutation<
        EntitySyncRejectLinkSuggestionApiResponse,
        EntitySyncRejectLinkSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/link-suggestions/${queryArg.suggestionId}/reject/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncGenerateLinkSuggestions: build.mutation<
        EntitySyncGenerateLinkSuggestionsApiResponse,
        EntitySyncGenerateLinkSuggestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/link-suggestions/generate/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncListLinks: build.query<
        EntitySyncListLinksApiResponse,
        EntitySyncListLinksApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/links/`,
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["matters"],
      }),
      entitySyncCreateLink: build.mutation<
        EntitySyncCreateLinkApiResponse,
        EntitySyncCreateLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/links/`,
          method: "POST",
          body: queryArg.createLinkRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncRemoveLink: build.mutation<
        EntitySyncRemoveLinkApiResponse,
        EntitySyncRemoveLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/links/${queryArg.linkId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncIgnoreFinchEntity: build.mutation<
        EntitySyncIgnoreFinchEntityApiResponse,
        EntitySyncIgnoreFinchEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/links/ignore/`,
          method: "POST",
          body: queryArg.ignoreFinchEntityRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
      entitySyncListPairs: build.query<
        EntitySyncListPairsApiResponse,
        EntitySyncListPairsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/pairs/`,
          params: {
            include_unlinked: queryArg.includeUnlinked,
            link_status: queryArg.linkStatus,
          },
        }),
        providesTags: ["matters"],
      }),
      entitySyncTriggerSync: build.mutation<
        EntitySyncTriggerSyncApiResponse,
        EntitySyncTriggerSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/entity-sync/${queryArg.entityType}/sync/`,
          method: "POST",
        }),
        invalidatesTags: ["matters"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type EntitySyncListDataSuggestionsApiResponse =
  /** status 200  */ DataSuggestionsListResponseSchema;
export type EntitySyncListDataSuggestionsApiArg = {
  entityType: string;
  matterId: string;
  /** Filter by suggestion set status (PENDING, RESOLVED, etc.) */
  status?: string;
};
export type EntitySyncGetDataSuggestionSetApiResponse =
  /** status 200  */ FilevineEntitySyncSuggestionSetSchema;
export type EntitySyncGetDataSuggestionSetApiArg = {
  entityType: string;
  matterId: string;
  setId: string;
};
export type EntitySyncDismissDataSuggestionSetApiResponse =
  /** status 200  */ FilevineEntitySyncSuggestionSetSchema;
export type EntitySyncDismissDataSuggestionSetApiArg = {
  entityType: string;
  matterId: string;
  setId: string;
};
export type EntitySyncAcceptDataSuggestionApiResponse =
  /** status 200  */ FilevineEntitySyncSuggestionSchema;
export type EntitySyncAcceptDataSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
  acceptDataSuggestionRequestSchema: AcceptDataSuggestionRequestSchema;
};
export type EntitySyncApplyDataSuggestionApiResponse =
  /** status 202  */ FilevineEntitySyncSuggestionSchema;
export type EntitySyncApplyDataSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
};
export type EntitySyncRejectDataSuggestionApiResponse = unknown;
export type EntitySyncRejectDataSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
};
export type EntitySyncGenerateDataSuggestionsApiResponse =
  /** status 202  */ GenerateSuggestionsResponseSchema;
export type EntitySyncGenerateDataSuggestionsApiArg = {
  entityType: string;
  matterId: string;
  generateSuggestionsRequestSchema: GenerateSuggestionsRequestSchema;
};
export type EntitySyncGetDataSuggestionApiResponse =
  /** status 200  */ FilevineEntitySyncSuggestionSchema;
export type EntitySyncGetDataSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
};
export type EntitySyncFieldConfigApiResponse =
  /** status 200  */ FilevineSectionConfigWithFieldsSchema;
export type EntitySyncFieldConfigApiArg = {
  entityType: string;
  matterId: string;
};
export type EntitySyncRunFullPipelineApiResponse =
  /** status 202  */ GenerateSuggestionsResponseSchema;
export type EntitySyncRunFullPipelineApiArg = {
  entityType: string;
  matterId: string;
  generateSuggestionsRequestSchema: GenerateSuggestionsRequestSchema;
};
export type EntitySyncGetPipelineStatusApiResponse = /** status 200  */ {
  workflow_id?: string;
  overall_status?: "RUNNING" | "COMPLETED" | "FAILED";
  current_step?: string | null;
  error_message?: string | null;
  entity_sync_status?: string;
  entity_sync_workflow_id?: string | null;
  link_suggestions_status?: string;
  link_suggestions_count?: number | null;
  data_suggestions_status?: string;
  data_suggestions_workflow_id?: string | null;
  data_suggestions_result?: object | null;
};
export type EntitySyncGetPipelineStatusApiArg = {
  entityType: string;
  matterId: string;
  /** The workflow ID returned from run_full_pipeline */
  workflowId: string;
};
export type EntitySyncListLinkSuggestionsApiResponse =
  /** status 200  */ EntityLinkSchema;
export type EntitySyncListLinkSuggestionsApiArg = {
  entityType: string;
  matterId: string;
};
export type EntitySyncApproveLinkSuggestionApiResponse =
  /** status 200  */ EntityLinkSchema;
export type EntitySyncApproveLinkSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
};
export type EntitySyncRejectLinkSuggestionApiResponse = unknown;
export type EntitySyncRejectLinkSuggestionApiArg = {
  entityType: string;
  matterId: string;
  suggestionId: string;
};
export type EntitySyncGenerateLinkSuggestionsApiResponse =
  /** status 200  */ GenerateLinkSuggestionsResponseSchema;
export type EntitySyncGenerateLinkSuggestionsApiArg = {
  entityType: string;
  matterId: string;
};
export type EntitySyncListLinksApiResponse =
  /** status 200  */ EntityLinkSchema;
export type EntitySyncListLinksApiArg = {
  entityType: string;
  matterId: string;
  /** Filter by link status */
  status?: string[];
};
export type EntitySyncCreateLinkApiResponse =
  /** status 201  */ EntityLinkSchema;
export type EntitySyncCreateLinkApiArg = {
  entityType: string;
  matterId: string;
  createLinkRequestSchema: CreateLinkRequestSchema;
};
export type EntitySyncRemoveLinkApiResponse = unknown;
export type EntitySyncRemoveLinkApiArg = {
  entityType: string;
  linkId: string;
  matterId: string;
};
export type EntitySyncIgnoreFinchEntityApiResponse =
  /** status 201  */ EntityLinkSchema;
export type EntitySyncIgnoreFinchEntityApiArg = {
  entityType: string;
  matterId: string;
  ignoreFinchEntityRequestSchema: IgnoreFinchEntityRequestSchema;
};
export type EntitySyncListPairsApiResponse =
  /** status 200  */ EntityPairsResponseSchemaRead;
export type EntitySyncListPairsApiArg = {
  entityType: string;
  /** Include unlinked entities from both systems */
  includeUnlinked?: boolean;
  /** Filter by link status (SUGGESTED, APPROVED, etc.) */
  linkStatus?: string[];
  matterId: string;
};
export type EntitySyncTriggerSyncApiResponse =
  /** status 202  */ GenerateSuggestionsResponseSchema;
export type EntitySyncTriggerSyncApiArg = {
  entityType: string;
  matterId: string;
};
export type CanonicalSectionType = "medical_providers" | "coverage";
export type FilevineEntitySyncSuggestionSetStatus =
  | "PENDING"
  | "PARTIALLY_RESOLVED"
  | "RESOLVED"
  | "SUPERSEDED";
export type FilevineEntitySyncSuggestionActionType =
  | "CREATE"
  | "UPDATE"
  | "NO_CHANGE";
export type FilevineEntitySyncSuggestionStatus =
  | "PENDING"
  | "ACCEPTED"
  | "REJECTED"
  | "SKIPPED"
  | "EXECUTING"
  | "COMPLETED"
  | "FAILED";
export type CreateContactPhoneInput = {
  number: string;
  phone_label_id?: number | null;
};
export type CreateContactEmailInput = {
  address: string;
  email_label_id?: number | null;
};
export type CreateContactAddressInput = {
  line1: string;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  address_label_id?: number | null;
};
export type CreateContactInput = {
  /** First name, or full name if is_single_name is True. */
  first_name: string;
  /** Last name. Usually empty when is_single_name is True. */
  last_name?: string | null;
  middle_name?: string | null;
  prefix?: string | null;
  suffix?: string | null;
  /** True for organizations or single-name entities. */
  is_single_name?: boolean;
  /** Company/organization this contact is associated with. */
  from_company?: string | null;
  department?: string | null;
  job_title?: string | null;
  phones?: CreateContactPhoneInput[];
  emails?: CreateContactEmailInput[];
  addresses?: CreateContactAddressInput[];
};
export type CreateNewContact = {
  action: "CREATE_NEW_CONTACT";
  payload: CreateContactInput;
};
export type LinkExistingContact = {
  action: "LINK_EXISTING_CONTACT";
  /** The contact id of the person to update the field with */
  contact_id: number;
};
export type DocumentFieldUpdatePayload = {
  /** The document id of the document to update the field with */
  document_id: number;
};
export type DeadlineFieldUpdatePayload = {
  /** The date due of the deadline to update the field with */
  date_due?: string | null;
  /** The date done of the deadline to update the field with */
  date_done?: string | null;
};
export type ProjectLinkFieldUpdatePayload = {
  /** The project id of the project to update the field with */
  project_id: number;
};
export type FilevineSectionPayload = {
  /** Dictionary of field updates to apply to the Filevine entity */
  updates?: {
    [key: string]:
      | number
      | string
      | string
      | boolean
      | (
          | ({
              action: "CREATE_NEW_CONTACT";
            } & CreateNewContact)
          | ({
              action: "LINK_EXISTING_CONTACT";
            } & LinkExistingContact)
        )
      | DocumentFieldUpdatePayload[]
      | DeadlineFieldUpdatePayload
      | string
      | string[]
      | ProjectLinkFieldUpdatePayload[];
  };
  /** List of field names to clear/delete/nullify */
  fields_to_clear?: string[];
};
export type FilevineSyncSuggestionSchema = {
  id: string | string;
  suggestion_set_id: string | string;
  action_type: FilevineEntitySyncSuggestionActionType;
  status: FilevineEntitySyncSuggestionStatus;
  direction: "TO_FILEVINE";
  affected_fields?: string[];
  confidence?: number;
  reasoning?: string | null;
  status_updated_by_id?: (string | string) | null;
  status_updated_at?: string | null;
  workflow_id?: string | null;
  workflow_status?: string | null;
  executed_at?: string | null;
  completed_at?: string | null;
  error_message?: string | null;
  before_snapshot?: {
    [key: string]: any;
  } | null;
  after_snapshot?: {
    [key: string]: any;
  } | null;
  changed_fields?: string[];
  created_at: string;
  modified_at: string;
  suggested_payload?: FilevineSectionPayload;
  modified_payload?: FilevineSectionPayload;
};
export type FinchSyncSuggestionSchema = {
  id: string | string;
  suggestion_set_id: string | string;
  action_type: FilevineEntitySyncSuggestionActionType;
  status: FilevineEntitySyncSuggestionStatus;
  direction: "TO_FINCH";
  affected_fields?: string[];
  confidence?: number;
  reasoning?: string | null;
  status_updated_by_id?: (string | string) | null;
  status_updated_at?: string | null;
  workflow_id?: string | null;
  workflow_status?: string | null;
  executed_at?: string | null;
  completed_at?: string | null;
  error_message?: string | null;
  before_snapshot?: {
    [key: string]: any;
  } | null;
  after_snapshot?: {
    [key: string]: any;
  } | null;
  changed_fields?: string[];
  created_at: string;
  modified_at: string;
  suggested_payload?: {
    [key: string]: any;
  } | null;
  modified_payload?: {
    [key: string]: any;
  } | null;
};
export type FilevineEntitySyncSuggestionSchema =
  | ({
      direction: "TO_FILEVINE";
    } & FilevineSyncSuggestionSchema)
  | ({
      direction: "TO_FINCH";
    } & FinchSyncSuggestionSchema);
export type FilevineEntitySyncSuggestionSetSchema = {
  id: string | string;
  entity_link_id?: (string | string) | null;
  finch_entity_id?: (string | string) | null;
  filevine_collection_item_id?: (string | string) | null;
  link_type: CanonicalSectionType;
  matter_id: string | string;
  status: FilevineEntitySyncSuggestionSetStatus;
  confidence?: number;
  reasoning?: string | null;
  workflow_run_id?: string | null;
  created_at: string;
  modified_at: string;
  suggestions?: FilevineEntitySyncSuggestionSchema[];
};
export type DataSuggestionsListResponseSchema = {
  suggestion_sets?: FilevineEntitySyncSuggestionSetSchema[];
  total_sets?: number;
  pending_sets?: number;
  /** Pending TO_FINCH suggestions */
  pending_to_finch?: number;
  /** Pending TO_FILEVINE suggestions */
  pending_to_filevine?: number;
  /** Suggestions with confidence >= 0.9 */
  high_confidence_count?: number;
  /** Suggestions with confidence < 0.7 */
  needs_review_count?: number;
};
export type AcceptDataSuggestionRequestSchema = {
  /** Optional modified payload to use instead of the suggested one */
  modified_payload?: FilevineSectionPayload;
};
export type GenerateSuggestionsResponseSchema = {
  /** Temporal workflow ID for tracking progress */
  workflow_id: string;
  message?: string;
};
export type GenerateSuggestionsRequestSchema = {
  /** Mark existing pending suggestions as superseded */
  supersede_existing?: boolean;
};
export type FilevineSectionConfigDataSchema = {
  mainLeftFieldID?: number | null;
  mainRightFieldID?: number | null;
  [key: string]: any;
};
export type FilevineSectionFieldConfigDataSchema = {
  row: number;
  column?: number | null;
  notes?: string | null;
  [key: string]: any;
};
export type FilevineSectionFieldConfigSchema = {
  id: string | string;
  section_id: string | string;
  filevine_id: number;
  name: string;
  internal_name: string;
  field_selector: string;
  custom_field_type: number;
  dropdown_items: string[];
  is_obsolete: boolean;
  is_required: boolean;
  person_filter: number;
  data: FilevineSectionFieldConfigDataSchema;
  created_at: string;
  modified_at: string;
};
export type FilevineSectionConfigWithFieldsSchema = {
  id: string | string;
  project_type_id: string | string;
  filevine_id: number;
  name: string;
  internal_name: string;
  data: FilevineSectionConfigDataSchema;
  created_at: string;
  modified_at: string;
  field_configs: FilevineSectionFieldConfigSchema[];
};
export type CollectionItemLinkStatus =
  | "SUGGESTED"
  | "APPROVED"
  | "HIDDEN"
  | "REJECTED"
  | "IGNORED";
export type EntityLinkSchema = {
  id: string | string;
  finch_entity_id: string | string;
  /** The Filevine entity ID. Null for IGNORED links. */
  filevine_entity_id?: (string | string) | null;
  link_status?: CollectionItemLinkStatus;
  confidence?: number;
  reasoning?: string | null;
  status_updated_by?: (string | string) | null;
  status_updated_at?: string | null;
};
export type GenerateLinkSuggestionsResponseSchema = {
  /** Number of new link suggestions created */
  suggestions_created: number;
  /** The newly created link suggestions */
  suggestions?: EntityLinkSchema[];
};
export type CreateLinkRequestSchema = {
  /** ID of the Finch entity to link */
  finch_entity_id: string | string;
  /** ID of the Filevine entity to link */
  filevine_entity_id: string | string;
};
export type IgnoreFinchEntityRequestSchema = {
  /** ID of the Finch entity to mark as ignored */
  finch_entity_id: string | string;
};
export type AddressContactHandleSchema = {
  /** Notes about the contact handle */
  notes?: string | null;
  /** Label for the contact handle */
  label?: string | null;
  handle_type: "ADDRESS";
  line1: string;
  /** Second line of the address */
  line2?: string | null;
  /** Third line of the address */
  line3?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
};
export type EmailContactHandleSchema = {
  /** Notes about the contact handle */
  notes?: string | null;
  /** Label for the contact handle */
  label?: string | null;
  handle_type: "EMAIL";
  handle_value: string;
};
export type FaxContactHandleSchema = {
  /** Notes about the contact handle */
  notes?: string | null;
  /** Label for the contact handle */
  label?: string | null;
  handle_type: "FAX";
  handle_value: string;
};
export type PhoneContactHandleSchema = {
  /** Notes about the contact handle */
  notes?: string | null;
  /** Label for the contact handle */
  label?: string | null;
  handle_type: "PHONE";
  handle_value: string;
};
export type ProviderTreatmentStatus =
  | "TREATING"
  | "COMPLETED"
  | "DEVIATING"
  | "UNKNOWN"
  | "REFERRED_TO";
export type ProviderType = "ORGANIZATION" | "PRACTITIONER";
export type TreatmentRecordTypes =
  | "Bills"
  | "Records"
  | "Facility Records"
  | "Facility Bills"
  | "Radiology"
  | "ER Physician Bills"
  | "Other"
  | "Unknown";
export type TreatmentRecordRequestStatus =
  | "not_ready"
  | "pending"
  | "request_submitted"
  | "request_received"
  | "awaiting_invoice"
  | "pending_payment"
  | "records_pending"
  | "records_delivered"
  | "records_ingested"
  | "rejected"
  | "cancelled"
  | "auto_retried";
export type FileSchema = {
  id?: (string | string) | null;
  name: string;
  url?: string | null;
  sha1_hash?: string | null;
  mime_type?: string | null;
  size_bytes?: number | null;
  uploaded_at?: string | null;
};
export type RecordRequestSchema = {
  id?: (string | string) | null;
  /** ID of the provider this request is for */
  provider_id: string | string;
  /** Date when the request was submitted */
  request_date?: string | null;
  /** Records that were provided by the provider */
  provided_records?: TreatmentRecordTypes[];
  /** Date when records were received */
  received_date?: string | null;
  /** Current status of the record request */
  request_status?: TreatmentRecordRequestStatus;
  /** Notes about the record request */
  notes?: string | null;
  /** Files associated with this record request */
  files?: FileSchema[];
};
export type TreatmentCareLevel =
  | "EMERGENCY_CARE"
  | "CONSERVATIVE_CARE"
  | "DIAGNOSTIC_TESTING"
  | "SPECIALIST_CARE"
  | "SURGICAL_CARE";
export type EncounterSummarySchema = {
  /** Date of service */
  date_of_service?: string | null;
  /** Services provided during this encounter */
  services?: string[];
};
export type MedicalProviderEntitySchema = {
  id: string | string;
  /** Name of the contact */
  name: string;
  /** General notes about the contact */
  notes?: string | null;
  /** Contact handles (phone, fax, email, address, etc.) */
  handles?: (
    | ({
        handle_type: "ADDRESS";
      } & AddressContactHandleSchema)
    | ({
        handle_type: "EMAIL";
      } & EmailContactHandleSchema)
    | ({
        handle_type: "FAX";
      } & FaxContactHandleSchema)
    | ({
        handle_type: "PHONE";
      } & PhoneContactHandleSchema)
  )[];
  /** Provider specialty or services offered */
  specialty?: string | null;
  /** Current treatment status of the provider */
  status: ProviderTreatmentStatus;
  /** Whether the provider is an organization or individual practitioner */
  provider_type?: ProviderType;
  /** AI-generated summary of the provider's role in the case */
  description?: string | null;
  /** Date when treatment started with this provider */
  treatment_start_date?: string | null;
  /** Date when treatment ended with this provider */
  treatment_end_date?: string | null;
  /** Record requests for this provider */
  record_requests?: RecordRequestSchema[];
  /** Care level of the provider (EMERGENCY_CARE, CONSERVATIVE_CARE, etc.) */
  care_level?: TreatmentCareLevel;
  /** Dates of service and services provided at this provider */
  encounters?: EncounterSummarySchema[];
  /** Name of the linked provider directory service, if any */
  provider_service_name?: string | null;
};
export type CoverageCategory =
  | "FIRST_PARTY"
  | "FIRST_PARTY_HEALTH"
  | "THIRD_PARTY"
  | "NOT_LIABLE_INVOLVED_PARTY"
  | "UNCLEAR"
  | "PROPERTY"
  | "WORKERS_COMPENSATION";
export type PolicyType =
  | "AUTO"
  | "HOMEOWNERS"
  | "COMMERCIAL"
  | "HEALTH"
  | "UMBRELLA"
  | "WORKERS_COMPENSATION"
  | "GENERAL_LIABILITY"
  | "OTHER";
export type CoverageStatus =
  | "NEEDS_APPROVAL"
  | "APPROVED"
  | "REJECTED"
  | "NOT_APPLICABLE";
export type CoverageLiabilityStatus =
  | "ACCEPTED"
  | "REJECTED"
  | "PARTIALLY_ACCEPTED"
  | "LIABILITY_UNKNOWN"
  | "UNDER_INVESTIGATION";
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type IdentifierType =
  | "POLICY_NUMBER"
  | "MEMBER_ID"
  | "GROUP_NUMBER"
  | "OTHER";
export type PolicyIdentifier = {
  /**
            The type of identifier for the policy.
             */
  identifier_type: IdentifierType;
  /**
            The value of the identifier for the policy.
             */
  identifier_value: string;
};
export type BenefitType =
  | "PERSONAL_INJURY_PROTECTION"
  | "MEDICAL_PAYMENTS"
  | "UNINSURED_MOTORIST"
  | "UNDER_INSURED_MOTORIST"
  | "BODILY_INJURY_LIABILITY"
  | "PROPERTY_DAMAGE_LIABILITY"
  | "COMPREHENSIVE_AUTO"
  | "COLLISION_AUTO"
  | "WORKERS_COMPENSATION"
  | "OTHER";
export type CoverageDataSource =
  | "UNKNOWN"
  | "BPO"
  | "USER_EDIT"
  | "SYSTEM"
  | "VOICE_AI";
export type CoverageDataSourceInfo = {
  /** The source that created or last modified this data. */
  source?: CoverageDataSource;
  /** User ID if source is USER_EDIT. */
  user_id?: string | null;
  /** User display name if source is USER_EDIT (for display purposes). */
  user_name?: string | null;
  /** When the data was added/modified from this source. */
  timestamp?: string | null;
};
export type AdjusterDetail = {
  /**
            The benefit the adjuster is specifically assigned to, if explicitly stated, otherwise null.
             */
  benefit_type?: BenefitType;
  /**
            Name of the adjuster handling a related claim if explicitly stated, otherwise null.
             */
  name?: string | null;
  /**
            The BEST (at MOST 2 handles per type) contact methods for the adjuster (phone, email, fax) if explicitly stated,
            otherwise null.
             */
  handles?: ContactHandleSchema[] | null;
  /**
            Metadata about the source of this adjuster data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type ClaimDetail = {
  /**
            The benefit against which the claim is being made, if explicitly stated, otherwise null.
            
            <benefits-type-glossary>
                PIP == PERSONAL_INJURY_PROTECTION
                MEDPAY == MEDICAL_PAYMENTS
                UM == UNINSURED_MOTORIST
                UIM == UNDER_INSURED_MOTORIST
                BI == BODILY_INJURY_LIABILITY
                COMPREHENSIVE == COMPREHENSIVE_AUTO
                COLLISION == COLLISION_AUTO
                anything else == OTHER
            </benefits-type-glossary>
              
             */
  benefit_type?: BenefitType;
  /**
            The claim identifier (number, id, etc.) for the policy, if explicitly stated, otherwise null.
             */
  claim_identifier?: string | null;
  /**
            Metadata about the source of this claim data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type BenefitDetail = {
  /**
            A limited categorization of insurance benefits we are interested in extracting.
            
            <benefits-type-glossary>
                PIP == PERSONAL_INJURY_PROTECTION
                MEDPAY == MEDICAL_PAYMENTS
                UM == UNINSURED_MOTORIST
                UIM == UNDER_INSURED_MOTORIST
                BI == BODILY_INJURY_LIABILITY
                COMPREHENSIVE == COMPREHENSIVE_AUTO
                COLLISION == COLLISION_AUTO
                anything else == OTHER
            </benefits-type-glossary>
              
             */
  benefit_type?: BenefitType;
  /**
            Structured map of coverage limitation labels to their numeric dollar amounts.
            Keys describe the limit type (e.g., "per person", "per accident", "bodily injury per person").
            Values MUST be integers representing dollar amounts (e.g., 25000 for $25,000).
    
            IMPORTANT: Do NOT use slash notation like "25000/50000". Instead, create SEPARATE entries:
            - WRONG: {"bodily injury": "25000/50000"}
            - CORRECT: {"bodily injury per person": 25000, "bodily injury per accident": 50000}
    
            Examples:
            - {"per person": 100000, "per accident": 300000}
            - {"BI per person": 25000, "BI per accident": 50000, "PD": 25000}
            - {"medical payments": 5000}
             */
  limitations?: {
    [key: string]: number;
  } | null;
  /**
            Whether stacking benefits apply for UM/UIM coverage. When true, coverage limits from
            multiple policies can be combined. Only applicable for UNINSURED_MOTORIST and
            UNDER_INSURED_MOTORIST benefit types. Null indicates unknown/not specified.
             */
  is_stacked?: boolean | null;
};
export type CoverageEntitySchema = {
  id: string | string;
  /** Coverage party classification (FIRST_PARTY, THIRD_PARTY, etc.) */
  category?: CoverageCategory;
  /** Type of insurance policy (AUTO, HEALTH, etc.) */
  policy_type?: PolicyType;
  /** Current approval status of the coverage */
  status?: CoverageStatus;
  /** Liability determination status */
  liability_status?: CoverageLiabilityStatus;
  /** Name of the insurance carrier (derived from carrier/division) */
  carrier_name?: string | null;
  /** Carrier contact handles (phone, fax, email, website) */
  carrier_contact_handles?: ContactHandleSchema[];
  /** Carrier headquarters address */
  carrier_address?: string | null;
  /** Policy numbers and other identifiers */
  policy_identifiers?: PolicyIdentifier[];
  /** Names of primary policyholders */
  named_insured?: string[];
  /** Adjusters handling claims against this policy */
  adjusters?: AdjusterDetail[];
  /** Claims opened against the policy */
  claims?: ClaimDetail[];
  /** Benefits covered by the policy */
  benefits?: BenefitDetail[];
};
export type BaseEntitySchema = {
  id: string | string;
};
export type PersonTypeSchema = {
  id: number;
  name: string;
  badgeColorClass?: string | null;
  isDeprecated: boolean;
  includeBirthdateField: boolean;
  globalSourceGuid: string;
};
export type ProjectTagSchema = {
  id: number;
  name: string;
  isDeprecated?: boolean | null;
  isArchived?: boolean | null;
  description?: string | null;
};
export type PhoneLabelSchema = {
  isSmsable: boolean;
  isFaxable: boolean;
  id: number;
  name: string;
  icon: string;
  isDeprecated: boolean;
  globalSourceGuid: string;
};
export type PhoneSchema = {
  id: number;
  number: string;
  extension?: string | null;
  rawNumber: string;
  isSmsable: boolean;
  isFaxable: boolean;
  label?: string | null;
  phoneLabel?: PhoneLabelSchema;
  notes?: string | null;
};
export type EmailSchema = {
  id: number;
  address: string;
  emailLabel?: string | null;
  label?: string | null;
  notes?: string | null;
};
export type AddressSchema = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  province_or_state?: string | null;
  postal_or_zip?: string | null;
  country_code?: string | null;
};
export type ProjectClientSchema = {
  id: number;
  contactNumber?: string | null;
  orgID: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  fullname: string;
  isSingleName: boolean;
  fromCompany?: string | null;
  primaryLanguage?: string | null;
  orgMetaVersionID: number;
  jobTitle?: string | null;
  department?: string | null;
  prefix?: string | null;
  suffix?: string | null;
  fullnameExtended?: string | null;
  nickname?: string | null;
  initials?: string | null;
  initialsFirstLast?: string | null;
  personTypes?: PersonTypeSchema[];
  tags?: (ProjectTagSchema | string)[];
  isArchived: boolean;
  createdDate?: string | null;
  modifiedDate?: string | null;
  phones?: PhoneSchema[];
  emails?: EmailSchema[];
  addresses?: AddressSchema[];
  pictureUrl?: string | null;
  pictureKey?: string | null;
  birthDate?: string | null;
  deathDate?: string | null;
  isDeceased?: boolean | null;
  ageInYears?: number | null;
  uniqueID?: string | null;
  abbreviatedName?: string | null;
  ssn?: string | null;
  notes?: string | null;
  specialty?: string | null;
  gender?: string | null;
  language?: string | null;
  maritalStatus?: string | null;
  isTextingPermitted?: boolean | null;
  remarket?: boolean | null;
  driverLicenseNumber?: string | null;
  isTypeClient?: boolean | null;
  isTypeAdjuster?: boolean | null;
  isTypeDefendant?: boolean | null;
  isTypePlaintiff?: boolean | null;
  isTypeAttorney?: boolean | null;
  isTypeFirm?: boolean | null;
  isTypeExpert?: boolean | null;
  isTypeMedicalProvider?: boolean | null;
  isTypeInvolvedParty?: boolean | null;
  isTypeJudge?: boolean | null;
  isTypeCourt?: boolean | null;
  isTypeInsuranceCompany?: boolean | null;
  salutation?: string | null;
  barNumber?: string | null;
  fiduciary?: string | null;
  isMinor?: boolean | null;
  searchNames?: string[];
};
export type ComputedFieldValue = {
  value?: (string | number | number) | null;
  error?: string | null;
};
export type ItemHeaderValue = {
  createdDate: string;
};
export type AttachedDocument = {
  id: number;
  orgID: number;
  docKey: string;
  contract?: string | null;
  filename: string;
  isPending?: boolean | null;
  projectID: number;
  contractID?: number | null;
  lockedTime?: string | null;
  templateID?: number | null;
  uploadDate?: string | null;
  isProtected?: boolean | null;
  templateName?: string | null;
  canEditInPlace: boolean;
  lockedByUserID?: number | null;
  reportFusionID?: number | null;
  reportFusionName?: string | null;
  lockExpirationTime?: string | null;
  antivirusScanResult: any[];
  lockedByUserFullName?: string | null;
  isProtectedPlaceholder?: boolean | null;
};
export type FilevineCollectionItemSnapshotSchema = {
  id: string | string;
  collection_item_id: string | string;
  data: {
    [key: string]:
      | (
          | string
          | number
          | boolean
          | string
          | string
          | string[]
          | ProjectClientSchema
          | ComputedFieldValue
          | ItemHeaderValue
          | AttachedDocument[]
        )
      | null;
  };
  created_at: string;
  modified_at: string;
};
export type DetailedFilevineCollectionItemSchema = {
  id: string | string;
  section_id: string | string;
  project_id: string | string;
  filevine_id: string;
  created_at: string;
  modified_at: string;
  latest_snapshot: FilevineCollectionItemSnapshotSchema;
};
export type SyncStatus =
  | "UNLINKED"
  | "LINK_SUGGESTED"
  | "LINKED"
  | "SYNC_PENDING"
  | "NEEDS_REVIEW";
export type EntityPairSchema = {
  /** The Finch entity (e.g., medical provider) in this pair */
  finch_entity?:
    | (MedicalProviderEntitySchema | CoverageEntitySchema | BaseEntitySchema)
    | null;
  /** The Filevine collection item in this pair */
  filevine_entity?: DetailedFilevineCollectionItemSchema;
  /** The approved or suggested link between entities */
  link?: EntityLinkSchema;
  /** Pending link suggestions for this entity pair */
  link_suggestions?: EntityLinkSchema[];
  /** Pending data sync suggestions for this entity pair */
  data_suggestion_set?: FilevineEntitySyncSuggestionSetSchema;
  /** Computed overall sync status of this entity pair. */
  sync_status: SyncStatus;
};
export type EntityPairSchemaRead = {
  /** The Finch entity (e.g., medical provider) in this pair */
  finch_entity?:
    | (MedicalProviderEntitySchema | CoverageEntitySchema | BaseEntitySchema)
    | null;
  /** The Filevine collection item in this pair */
  filevine_entity?: DetailedFilevineCollectionItemSchema;
  /** The approved or suggested link between entities */
  link?: EntityLinkSchema;
  /** Pending link suggestions for this entity pair */
  link_suggestions?: EntityLinkSchema[];
  /** Pending data sync suggestions for this entity pair */
  data_suggestion_set?: FilevineEntitySyncSuggestionSetSchema;
  /** Whether the entities are linked (approved status). */
  is_linked: boolean;
  /** Whether there are pending link suggestions. */
  has_pending_link_suggestion: boolean;
  /** Whether there are pending data sync suggestions. */
  has_pending_data_suggestion: boolean;
  /** Computed overall sync status of this entity pair. */
  sync_status: SyncStatus;
};
export type EntityPairsResponseSchema = {
  pairs?: EntityPairSchema[];
  total_count?: number;
  /** Number of approved links */
  linked_count?: number;
  /** Number of suggested links */
  suggested_count?: number;
  /** Finch entities without links */
  unlinked_finch_count?: number;
  /** Filevine entities without links */
  unlinked_filevine_count?: number;
  /** Pairs with pending sync suggestions */
  pending_sync_count?: number;
};
export type EntityPairsResponseSchemaRead = {
  pairs?: EntityPairSchemaRead[];
  total_count?: number;
  /** Number of approved links */
  linked_count?: number;
  /** Number of suggested links */
  suggested_count?: number;
  /** Finch entities without links */
  unlinked_finch_count?: number;
  /** Filevine entities without links */
  unlinked_filevine_count?: number;
  /** Pairs with pending sync suggestions */
  pending_sync_count?: number;
};
export const {
  useEntitySyncListDataSuggestionsQuery,
  useEntitySyncGetDataSuggestionSetQuery,
  useEntitySyncDismissDataSuggestionSetMutation,
  useEntitySyncAcceptDataSuggestionMutation,
  useEntitySyncApplyDataSuggestionMutation,
  useEntitySyncRejectDataSuggestionMutation,
  useEntitySyncGenerateDataSuggestionsMutation,
  useEntitySyncGetDataSuggestionQuery,
  useEntitySyncFieldConfigQuery,
  useEntitySyncRunFullPipelineMutation,
  useEntitySyncGetPipelineStatusQuery,
  useEntitySyncListLinkSuggestionsQuery,
  useEntitySyncApproveLinkSuggestionMutation,
  useEntitySyncRejectLinkSuggestionMutation,
  useEntitySyncGenerateLinkSuggestionsMutation,
  useEntitySyncListLinksQuery,
  useEntitySyncCreateLinkMutation,
  useEntitySyncRemoveLinkMutation,
  useEntitySyncIgnoreFinchEntityMutation,
  useEntitySyncListPairsQuery,
  useEntitySyncTriggerSyncMutation,
} = injectedRtkApi;
